import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { handshakeService } from "@/services/handshakeService";
import type {
  HandshakeSessionDetail,
  HandshakeSessionPublicDetail,
} from "@/types";

export function handshakeSessionDetailQueryKey(
  sessionId: string,
  admin: boolean,
) {
  return ["handshake", "session", sessionId, admin ? "admin" : "seller"] as const;
}

export function useAdminHandshakeSessionDetail(
  sessionId: string | null | undefined,
  enabled = true,
): UseQueryResult<HandshakeSessionDetail> {
  return useQuery({
    queryKey: handshakeSessionDetailQueryKey(sessionId ?? "", true),
    queryFn: () => {
      if (!sessionId) {
        throw new Error("sessionId required");
      }
      return handshakeService.adminGetSessionDetail(sessionId);
    },
    enabled: enabled && !!sessionId,
  });
}

export function useSellerHandshakeSessionDetail(
  sessionId: string | null | undefined,
  enabled = true,
): UseQueryResult<HandshakeSessionPublicDetail> {
  return useQuery({
    queryKey: handshakeSessionDetailQueryKey(sessionId ?? "", false),
    queryFn: ({ signal }) => {
      if (!sessionId) {
        throw new Error("sessionId required");
      }
      return handshakeService.getSessionDetail(sessionId, { signal });
    },
    enabled: enabled && !!sessionId,
  });
}
